module.exports = __webpack_public_path__ + "img/p2.344e1799.png";